import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {GradientStopSvgDefaultBox} from "./gradient-stop-svg.default.box";
import {GradientStopSvgMrgreenBox} from "./gradient-stop-svg.mrgreen.box";
import {GradientStopSvgCasino777Box} from "./gradient-stop-svg.casino777.box";


export const GradientStopSvgBox = styledByTheme(GradientStopSvgDefaultBox)
    .forMrGreen(GradientStopSvgMrgreenBox)
    .forCasino777(GradientStopSvgCasino777Box)
    .apply();